import React from "react";
import { node } from "prop-types";

import * as S from "./styled";

const Section = ({ children, ...passThroughProps }) => (
  <S.Section {...passThroughProps}>{children}</S.Section>
);

Section.propTypes = {
  children: node.isRequired
};

export default Section;
